import { render } from "./T_shirt_2_back.vue?vue&type=template&id=4d550ce2"
import script from "./T_shirt_2_back.vue?vue&type=script&lang=js"
export * from "./T_shirt_2_back.vue?vue&type=script&lang=js"

import exportComponent from "/srv/users/dyo-frontend/apps/dyo-frontend/public_html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__